/**
 * Skyframe Dynamic Frame Overlay - FINAL VERSION
 * Frame border around entire product image
 */

console.log('🖼️ Skyframe overlay loaded');

(function() {
  'use strict';
  
  // Frame color styles
  const frameStyles = {
    'White Frame': {
      color: '#F5F5F5',
      shadow: 'inset 0 0 0 3px #E0E0E0'
    },
    'Black Frame': {
      color: '#1A1A1A',
      shadow: 'inset 0 0 0 3px #0A0A0A'
    },
    'Gold Frame': {
      color: '#D4AF37',
      shadow: 'inset 0 0 0 3px #B8941F'
    },
    'Natural Frame': {
      color: '#D2B48C',
      shadow: 'inset 0 0 0 3px #A89068'
    },
    'Silver Frame': {
      color: '#C0C0C0',
      shadow: 'inset 0 0 0 3px #A0A0A0'
    }
  };
  
  function removeAllOverlays() {
    const oldOverlays = document.querySelectorAll('.skyframe-overlay');
    oldOverlays.forEach(overlay => overlay.remove());
  }
  
  function applyFrame() {
    console.log('🔄 Applying frame overlay...');
    
    // Remove any existing overlays first
    removeAllOverlays();
    
    // Find selected frame color
    const selectedInput = document.querySelector('input[name*="Frame Color"]:checked');
    
    if (!selectedInput) {
      console.log('⚠️ No frame selected');
      return;
    }
    
    const frameColor = selectedInput.value;
    const frameStyle = frameStyles[frameColor];
    
    if (!frameStyle) {
      console.log('⚠️ Frame style not found for:', frameColor);
      return;
    }
    
    console.log('✅ Applying', frameColor);
    
    // Find ALL product images
    const mediaWrappers = document.querySelectorAll('.product__media.media-wrapper');
    console.log('📸 Found', mediaWrappers.length, 'images');
    
    // Apply overlay to each image
    mediaWrappers.forEach((wrapper, index) => {
      // Ensure wrapper is positioned
      wrapper.style.position = 'relative';
      
      // Create overlay
      const overlay = document.createElement('div');
      overlay.className = 'skyframe-overlay';
      overlay.style.cssText = `
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100% !important;
        height: 100% !important;
        border: 20px solid ${frameStyle.color} !important;
        box-shadow: ${frameStyle.shadow} !important;
        pointer-events: none !important;
        z-index: 100 !important;
        transition: all 0.4s ease !important;
        display: block !important;
      `;
      
      // Add overlay to wrapper
      wrapper.appendChild(overlay);
      
      console.log('✅ Frame #' + (index + 1) + ' applied:', frameColor);
    });
  }
  
  function init() {
    console.log('🚀 Initializing frame system...');
    
    // Initial apply after page loads
    setTimeout(() => {
      applyFrame();
    }, 800);
    
    // Listen for clicks on frame color inputs
    document.addEventListener('click', function(e) {
      const frameInput = e.target.closest('input[name*="Frame Color"]');
      if (frameInput) {
        console.log('🖱️ Frame clicked:', frameInput.value);
        // Wait a tiny bit for radio to update
        setTimeout(applyFrame, 100);
      }
    });
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();